module.exports = __webpack_public_path__ + "82ea47e82dea389c9ce2d954bec82e15.png";